import React from "react";

const copyrightsPng = "./assets/copyrights.png";
const copyrightsPng2x = "./assets/copyrights@2x.png 2x";

function CopyRights() {
    return (
        <div className="copyright_bg">
            <img src={copyrightsPng} srcSet={copyrightsPng2x} />
        </div>
    );
}

export default CopyRights;
